
/// <amd-module name="Search/Shared/Components/TreeDropdown/TreeDropdown.Props" />
import * as React from "react";

export enum SearchType {
    Path,
    Keyword,
    None
}

export interface IComboBox {
    getInputRef: () => HTMLElement | null;
}

export interface IComboBoxProps {
    /**
    * If false, disables the button.
    */
    enabled: boolean;

    /**
    * Text used to label the left side part of the control.
    */
    comboBoxLabel: string;

    /**
    * If true, component renders a spinner signifying operations in progress.
    */
    showBusy?: boolean;

    /**
    * Set it tro true if combo box can recieve input.
    */
    editable?: boolean;

    /**
    * If true, control is active. Used to control tooltip and visibility of the label.
    */
    dropdownActive?: boolean;

    /**
    * Default text to be placed in the input box.
    */
    comboBoxText?: string;

    /**
    * Place holder to fill in the input box in abscence of any text.
    */
    placeholder?: string;

    /**
    * Aria label used for clear icon
    */
    clearIconAriaLabel?: string;

    /**
    * Aria label used for apply button
    */
    applyButtonAriaLabel?: string;

    /**
    * Action performed on clicking chevron icon
    */
    onChevronClick?: (evt?: React.SyntheticEvent<HTMLElement>) => void;

    /**
    * Action performed when the control is clicked upon.
    */
    onComboBoxClick?: (evt?: React.SyntheticEvent<HTMLElement>) => void;

    /**
    * Action performed when the clear text icon is activated.
    */
    onClearText?: (evt?: React.SyntheticEvent<HTMLElement>) => void;

    /**
    * Invoked whenever the text in the input box changes.
    */
    onTextChanged?: (evt?: React.ChangeEvent<HTMLInputElement>) => void;

    /**
    * Action invoked when the input box recieves focus
    */
    onInputFocus?: (evt?: React.FocusEvent<HTMLElement>) => void;

    /**
    * Action invoked on keydown events on input box.
    */
    onInputKeyDown?: (evt?: React.KeyboardEvent<HTMLInputElement>) => void;

    /**
    * Action invoked apply button is activated.
    */
    onApplyText?: (evt?: React.SyntheticEvent<HTMLElement>) => void;

    /**
    * Delegate invoked with component reference when it has finished mounting.
    */
    componentRef?: (ref: IComboBox) => void;

    /**
    * Keeps title, content etc for the info popup when the control is disabled.
    */
    disabledInfoCalloutProps?: { [key: string]: string };

    /**
    * Id for the help icon 
    */
    helpIconId?: string;

    /**
    * Id for the tree dropdown 
    */
    treeDropdownId?: string;

}
